import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import Tag from '@monofront/design-system/components/Tag';
import { isMobileApp } from '@utils/environment';
import { sendMessageToMobile } from '@utils/mobile';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import useI18n from '@hooks/i18n/useI18n';

interface IOOSProductImageProps {
  handle: string;
  img?: string;
}

const OOSProductImage: React.FC<IOOSProductImageProps> = ({ handle, img }) => {
  const router = useRouter();
  const tCatalog = useTranslations('Catalog');
  const { isGermanMarket } = useI18n();

  const onClickItem = () => {
    isMobileApp
      ? sendMessageToMobile('goToProduct', { handle: handle })
      : router.push(`/products/${handle}`);
  };

  return (
    <>
      <a onClick={onClickItem} data-testid="OOSProductImage-go-to-product-page">
        <figure>
          <ResponsiveImage
            src={img!}
            alt={`img-${handle}`}
            width={100}
            height={100}
            quality={75}
            objectFit="cover"
          />
          {!isGermanMarket && (
            <div className="bottom -tw-translate-x-1">
              <Tag variant="danger-light">{tCatalog('comesBackSoon')}</Tag>
            </div>
          )}
        </figure>
      </a>
      <style jsx>{`
        a {
          position: relative;
          display: block;
        }

        figure {
          position: absolute;
          display: flex;
          flex-direction: column;
          cursor: pointer;
          height: 50px;
          width: 50px;
        }

        .bottom {
          position: absolute;
          justify-content: space-between;
          bottom: -50%;
          display: flex;
          align-items: flex-end;
        }

        .bottom :global(div) {
          padding: var(--space-1) var(--space-2);
          font-size: var(--font-size-1);
          text-align: center;
          margin-left: var(--negative-space-1);
        }

        @media (max-width: 800px) {
          figure {
            width: 60px;
            height: 60px;
          }

          .bottom {
            bottom: -30%;
            margin-left: var(--space-1);
          }
        }
      `}</style>
    </>
  );
};

export default OOSProductImage;
